import { render, staticRenderFns } from "./DeprecatedInfo.vue?vue&type=template&id=2c727db8&scoped=true&"
import script from "./DeprecatedInfo.vue?vue&type=script&lang=js&"
export * from "./DeprecatedInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeprecatedInfo.vue?vue&type=style&index=0&id=2c727db8&lang=stylus&scoped=true&"
import style1 from "./DeprecatedInfo.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c727db8",
  null
  
)

export default component.exports